// extracted by mini-css-extract-plugin
export default {"contain":"MFAScreen_contain__tAu9F","card":"MFAScreen_card__ho94j","field":"MFAScreen_field__LtzFB"};